import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {DashboardOPEEnum} from "./DashboardOPEEnum";

class O {

}

/**
 * O Inner Class
 */
class I {
  id!: number;
}


/**
 * GetDashboardsCB class
 */
export class DelDashboardWidgetCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(DashboardOPEEnum.DelDashboardWidget);
    this.i = new I();
    this.o = new O();
  }

}
